// @ts-strict-ignore
import styled from "styled-components";

export const SearchContainer = styled.div`
  display: none;
  position: relative;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  ${({ theme: { media } }) => media.tablet`
    display: flex;
  `}
`;

export const SearchIcon = styled.img`
  cursor: pointer;
  margin-right: 5px;
  max-height: 20px;
`;

export const SearchInput = styled.input`
  border: none;
`;

export const SuggestContainer = styled.aside`
  ${(props) => !props.active && "display: none;"}
  position: absolute;
  left: 0;
  background: white;
  padding-bottom: 24px;
  padding-top: 24px;
  right: 0;
  top: 30px;
  text-align: left;
  border: 1px solid ${({ theme }) => theme.borderColors.secondary};
  border-radius: 27px;
  overflow: hidden;
  z-index: 9;
`;

export const SuggestList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const SuggestItem = styled.li`
  padding: 16px 12px 16px 24px;
  transition: background-color ease 0.2s;
  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.backgroundColors.secondary};
  }
  background: ${({ highlighted, theme }) =>
    highlighted ? theme.backgroundColors.secondary : "transparent"};
`;
